import React from 'react';
import { Redirect } from 'wouter';

export const PaymentsHomePage = () => <Redirect to="/invoices" replace />;
